import React from 'react';
import { VipsImagesContainer } from './vips-images-container';
import styled from 'styled-components';
import { vipsImages } from '../utils/vips-images';
import { MotionValue } from 'framer-motion';

const VipsGaleriaContainer = styled.div<{ $horizontal: boolean }>`
	display: flex;
	flex-direction: ${(props: { $horizontal: boolean }) => (props.$horizontal ? 'column' : 'row')};
	align-items: center;
	justify-content: center;
	gap: 12px;
	height: 100vh;
	overflow: hidden;
	position: ${(props: { $horizontal: boolean }) => (props.$horizontal ? 'static' : 'absolute')};
	top: ${(props: { $horizontal: boolean }) => (props.$horizontal ? 'auto' : '0')};
	padding-bottom: ${(props: { $horizontal: boolean }) => (props.$horizontal ? 'var(--size-dynamic0200)' : '0')};

	@media screen and (max-width: 1279px) {
		position: sticky;
		width: 100%;
		height: fit-content;
	}

	@media screen and (min-width: 1280px) {
		position: ${(props: { $horizontal: boolean }) => (props.$horizontal ? 'unset' : 'absolute')};
	}
`;

const splitImagesIntoTracks = (images: string[], requestedTracks: number): string[][] => {
	if (images.length === 0) {
		return [];
	}

	const normalizedTrackCount = Math.max(1, Math.floor(requestedTracks));
	const totalTracks = Math.min(normalizedTrackCount, images.length);
	const tracks: string[][] = [];
	let startIndex = 0;

	for (let index = 0; index < totalTracks; index += 1) {
		const remainingImages = images.length - startIndex;
		const remainingTracks = totalTracks - index;
		const trackSize = Math.ceil(remainingImages / remainingTracks);

		tracks.push(images.slice(startIndex, startIndex + trackSize));
		startIndex += trackSize;
	}

	return tracks;
};

export const VipsGaleria = ({
	progress,
	rows,
	horizontal = false,
}: {
	progress: MotionValue<number>;
	rows: number;
	horizontal?: boolean;
}): React.ReactElement => {
	const imageTracks = splitImagesIntoTracks(vipsImages, rows).map((track) => [...track, ...track]);

	return (
		<VipsGaleriaContainer className="vips-galeria-container" $horizontal={horizontal}>
			{imageTracks.map((track, index) => (
				<VipsImagesContainer
					key={`vips-track-${index}`}
					scrollProgress={progress}
					images={track}
					direction={index % 2 === 0 ? 'rtl' : 'ltr'}
					horizontal={horizontal}
				/>
			))}
		</VipsGaleriaContainer>
	);
};
